module.exports = __webpack_public_path__ + "img/herb-and-garlic-baked-chicken.142dbe15.jpg";